module.exports = __webpack_public_path__ + "media/images/kumu-banner-518eecd3bda02d02ef538b5da03c8f6b.png";